import axios from 'axios';

// Use a relative baseURL so the API is always called on the same origin as
// the frontend. This avoids cross-origin issues (TLS, CORS, SameSite=Lax
// cookies) when the deployed bundle is served on a different domain than
// REACT_APP_BACKEND_URL was set to at build time.
//
// In every Emergent-hosted environment (preview AND production), the
// platform ingress routes `/api/*` from the frontend host straight to the
// FastAPI backend on port 8001 — so a relative path works everywhere.
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  // Send the httpOnly auth cookie automatically. Now always same-origin.
  withCredentials: true,
});

// AuthContext sets this so the response interceptor can decide whether a 401
// should bounce the user to /login (i.e. their session expired) vs silently
// reject (anonymous access to a freemium endpoint).
let isLoggedInResolver = () => false;
export const setIsLoggedInResolver = (fn) => {
  isLoggedInResolver = fn || (() => false);
};

// Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && isLoggedInResolver()) {
      // Session expired or was revoked server-side; drop local state and bounce.
      isLoggedInResolver = () => false;
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
